<template>
  <RotateFrame>
  <div id="withdraw-submitted">
    <div class="withdraw-submitted" v-if="!isUsdt">
      <img src="/assets/withdraw-us/success.png" class="success" alt="success" />

      <div class="f-1">Withdrawal Request Submitted</div>
      <div class="f-2">$ {{amount}}</div>

      <div class="info-c">
        <div class="info-c-l">
          <span class="info-c-l-s1">{{ isCard ? 'Withdrawal Card' : 'Withdrawal Account' }}</span>
          <span class="info-c-l-s2">{{ displayAccount }}</span>
        </div>
        <div class="info-c-l">
          <span class="info-c-l-s1">Amount received</span>
          <span class="info-c-l-s2">${{amount}}</span>
        </div>
        <div class="info-c-l">
          <span class="info-c-l-s1">Estimated Arrival Time</span>
          <span class="info-c-l-s2">1-3 Business Days</span>
        </div>
        <div class="info-c-l">
          <span class="info-c-l-s1">Order Number</span>
          <span class="info-c-l-s2">{{withdrawId}}</span>
        </div>
      </div>

      <div class="confirm-btn-2-group">
        <button class="confirm-btn-2" @click="backToHome">Back to Home</button>
        <div class="vwh" @click="toHistory">View Withdrawal History</div>
      </div>
    </div>

    <div class="withdraw-submitted" v-else>
      <img src="/assets/withdraw-us/success.png" class="success" alt="success" />

      <div class="f-1">Sending...</div>
      <div class="f-2">$ {{amount}}</div>
      <div class="f-1">USDT</div>

      <div class="f-3">
        We are sending your cryptocurrency to the corresponding address. It is expected to arrive within <span style="color: #4127b5">2 minutes.</span>
      </div>

      <div class="confirm-btn-2-group">
        <button class="confirm-btn-2" @click="backToHome">Back to Home</button>
        <div class="vwh" @click="toHistory">View Withdrawal History</div>
      </div>
    </div>
  </div>
  </RotateFrame>
</template>

<script>
import withdrawRem from './withdrawRem'
import RotateFrame from './RotateFrame.vue'

export default {
  components: { RotateFrame },
  mixins: [withdrawRem],
  data () {
    return {
      amount: null,
      withdrawId: null,
      account: null,
      paymentType: null,
      // TODO: Card 的 paymentType 待后端确认，与 withdraw-us.vue 的 CARD_TYPE 保持一致
      CARD_TYPE: 5
    }
  },
  computed: {
    isUsdt () {
      return Number(this.paymentType) === 4
    },
    isCard () {
      return Number(this.paymentType) === this.CARD_TYPE
    },
    // 卡号成功页掩码展示：前4 *****后4
    displayAccount () {
      if (!this.isCard || !this.account) return this.account
      const s = String(this.account)
      if (s.length <= 8) return s
      return `${s.slice(0, 4)}*****${s.slice(-4)}`
    }
  },
  methods: {
    backToHome () {
      if (window.history.length > 1) {
        this.$router.back()
      }
    },
    toHistory () {
      this.$router.push({ path: '/withdraw-history', query: { s: 1 } })
    }
  },
  created () {
    const query = this.$route.query
    this.amount = query.amount != null ? query.amount : null
    this.withdrawId = query.withdrawId != null ? query.withdrawId : null
    this.account = query.bankCardNumber != null ? query.bankCardNumber : null
    if (query.paymentType) {
      this.paymentType = query.paymentType
    }
  }
}
</script>

<style scoped>
* {
  padding: 0;
  margin: 0;
  color: #1B1B1D;
  font-size: 0.2rem;
}

.withdraw-submitted {
  height: 100vh;
  height: 100dvh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  width: 7.2rem;
  max-width: 7.2rem;
  margin: 0 auto;
  background-color: #FCF8FB;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#withdraw-submitted {
  height: 100vh;
  height: 100dvh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  width: 7.2rem;
  max-width: 7.2rem;
  margin: 0 auto;
  background-color: #FCF8FB;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.success {
  margin: .5rem 0;
  height: 3.76rem;
  width: 3.76rem;
}

.f-1 {
  margin-top: .2rem;
  font-weight: bold;
  font-size: .4rem;
  color: #1B1B1D;
}
.f-2 {
  font-weight: bold;
  font-size: .8rem;
  margin-top: .4rem;
  color: #1B1B1D;
}
.f-3 {
  text-align: center;
  font-size: .26rem;
  margin-top: .2rem;
  color: #1B1B1D;
}
.info-c {
  margin: .2rem;
  margin-top: .4rem;
  width: calc(100% - .4rem);
  background-color: #ffffff;
  border-radius: .2rem;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}
.info-c-l {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: .4rem .2rem;
  box-sizing: border-box;
}
.info-c-l-s1 {
  font-size: .26rem;
  color: #484554;
}

.info-c-l-s2 {
  font-size: .26rem;
  font-weight: bold;
  color: #484554;
}

.confirm-btn-2-group {
  bottom: .4rem;
  bottom: calc(.4rem + env(safe-area-inset-bottom, 0px));
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: .4rem;
  align-items: center;
}

.confirm-btn-2 {
  font-size: .32rem;
  margin-left: auto;
  margin-right: auto;
  width: 90%;
  height: 1rem;
  color: #fff;
  border: none;
  border-radius: 0.2rem;
  transition: all 0.2s;
  background: #4625BB;
  opacity: 1;
  cursor: pointer;
}

.vwh {
  color: #4625BB;
  font-size: .32rem;
}

/* 横屏：内容已由 RotateFrame 旋转成竖屏，页面铺满旋转框即可，按钮组保持 absolute（相对旋转框底部）*/
@media screen and (orientation: landscape) {
  #withdraw-submitted,
  .withdraw-submitted {
    width: 100%;
    max-width: none;
    height: 100%;
    margin: 0;
    overflow-y: auto;
  }
}
</style>
